// Chrome, actions, units, the practice/AI notices and the shortcut overlay —
// the copy every screen shares.
export const common = {
  // ── app ──────────────────────────────────────────────────────────────
  'app.title': 'پارسینا — پنل دانشجو و دستیار',

  // ── common ───────────────────────────────────────────────────────────
  'common.actions.cancel': 'انصراف',
  'common.actions.retry': 'تلاش مجدد',
  'common.actions.save': 'ذخیره',
  'common.actions.saving': 'در حال ذخیره…',
  'common.actions.back': 'بازگشت',
  'common.actions.add': 'افزودن',
  'common.actions.edit': 'ویرایش',
  'common.actions.delete': 'حذف',
  'common.actions.close': 'بستن',
  'common.actions.confirm': 'تأیید',
  'common.actions.create': 'ساختن',
  'common.actions.open': 'باز کردن',
  'common.actions.clear': 'پاک کردن',
  'common.actions.copy': 'کپی',
  'common.actions.copied': 'کپی شد',
  'common.actions.rename': 'تغییر نام',
  'common.actions.more': 'بیشتر',
  'common.actions.viewAll': 'مشاهدهٔ همه',
  'common.actions.continue': 'ادامه',
  'common.labels.none': '—',
  'common.labels.optional': 'اختیاری',
  'common.labels.search': 'جستجو',
  'common.labels.loading': 'در حال بارگذاری…',
  'common.state.all': 'همه',
  'common.state.pleaseWait': 'لطفاً صبر کنید…',
  'common.time.today': 'امروز',
  'common.time.yesterday': 'دیروز',
  'common.time.last7': '۷ روز گذشته',
  'common.time.older': 'قدیمی‌تر',
  'common.units.parseh': 'پارسه',
  'common.units.toman': 'تومان',
  'common.units.tomanShort': 'ت',
  'common.units.years': '{{count}} سال',
  'common.units.kg': 'کیلوگرم',
  'common.units.cm': 'سانتی‌متر',
  'common.units.second': 'ثانیه',
  'common.gender.male': 'مرد',
  'common.gender.female': 'زن',
  'common.gender.other': 'سایر',

  // ── mobile shell ─────────────────────────────────────────────────────
  'mobile.greeting': 'خوش آمدید،',
  'mobile.showMore': 'نمایش بیشتر',
  'mobile.close': 'بستن',
  'mobile.menu': 'منو',

  // ── the practice / teaching disclaimers — core.md §3 ─────────────────
  'practice.badge': 'بیمار تمرینی',
  'practice.badge.short': 'تمرینی',
  'practice.banner.title': 'این بیمار خیالی است',
  'practice.banner.body': 'هرچه اینجا می‌نویسید یک مورد آموزشی ساختهٔ خودتان است. هرگز اطلاعات یک فرد واقعی را وارد نکنید — نه نام، نه کد ملی، نه شمارهٔ تماس.',
  'practice.caseRef.label': 'برچسب شخصی پرونده',
  'practice.caseRef.helper': 'برچسب بایگانی خودتان — «مورد ۱۲»، «CASE-2026-03». این کد ملی نیست و هرگز نباید باشد.',
  'practice.ai.title': 'پاسخ آموزشی است، نه توصیهٔ بالینی',
  'practice.ai.body': 'دستیار استدلالش را توضیح می‌دهد تا آن را مطالعه کنید. پاسخ دربارهٔ یک بیمار خیالی است و هرگز نباید برای درمان فرد واقعی به کار رود.',
  'practice.ai.short': 'آموزشی است، نه توصیهٔ بالینی.',

  // ── keyboard shortcuts ───────────────────────────────────────────────
  'shortcuts.title': 'میانبرهای صفحه‌کلید',
  'shortcuts.groups.general': 'عمومی',
  'shortcuts.groups.visit': 'ویزیت',
  'shortcuts.search': 'جستجوی بیمار',
  'shortcuts.help': 'همین فهرست',
  'shortcuts.close': 'بستن پنجرهٔ باز',
  'shortcuts.empty': 'در این صفحه میانبری نیست.',
  // The static reference the `?` overlay shows OUTSIDE a visit: the bindings
  // only exist while a visit is open, but a student should be able to read them
  // before opening one.
  'shortcuts.groups.insideVisit': 'داخل ویزیت',

  // ── paging ───────────────────────────────────────────────────────────
  'common.pager.prev': 'قبلی',
  'common.pager.next': 'بعدی',
  'common.pager.page': 'صفحه {{current}} از {{pages}}',

  // ── connectivity banner — core.md §15 ────────────────────────────────
  'connectivity.offline': 'اینترنت قطع است — تغییرات ثبت نمی‌شود',
  'connectivity.degraded': 'ارتباط با سرور برقرار نیست — در حال تلاش مجدد',
  'connectivity.restored': 'اتصال دوباره برقرار شد',
  'connectivity.retry': 'بررسی دوباره',
  'connectivity.checking': 'در حال بررسی…',
};

export default common;
